/** @jsxImportSource @emotion/react */

import { Button } from "antd";
import { CommonIcons } from "assets/common/icons";
import { handleFavoriteGame } from "helpers/handleFavouriteGame";
import { handleLoginGame } from "helpers/handleLoginGame";
import { useAppDispatch } from "hooks/app-hook";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectIsAuthenticated, selectUsername } from "store/auth";
import { selectDataSubGameFavourite } from "store/game";
import { SubGameType } from "types/game";

import { MGameFavouriteCardStyle } from "./index.style";

const MGameFavouriteCard = (props: SubGameType) => {
  const { picture, provider_code, name } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const listGameFavourite = useSelector(selectDataSubGameFavourite);
  const username = useSelector(selectUsername);

  return (
    <div css={MGameFavouriteCardStyle.self}>
      <div css={MGameFavouriteCardStyle.imageWrapper}>
        <img
          src={picture}
          alt=""
          onClick={() => handleLoginGame(props, dispatch, navigate)}
        />
        <div css={MGameFavouriteCardStyle.provider}>{provider_code}</div>
        <Button type="text" css={MGameFavouriteCardStyle.btnHeart}>
          <CommonIcons.Heart
            css={MGameFavouriteCardStyle.heartIcon}
            onClick={() =>
              handleFavoriteGame(
                username,
                dispatch,
                props,
                listGameFavourite || [],
                isAuthenticated,
              )
            }
          />
        </Button>
      </div>
      <p css={MGameFavouriteCardStyle.name}>{name}</p>
    </div>
  );
};

export default MGameFavouriteCard;
